import LiveChat from '@html/_modules/live-chat';
import {
  sendGoogleEvent, sendAmplitudeEvent, parameters, scriptUrl, byUserInteraction, loadJs,
} from 'html/include/pw/_common/utils';

const EVENT_CATEGORY = 'Deals page';

export default function AOClpColumns() {
  const saleLinkClickEvent = () => {
    $('.js-ao-clp-columns__sale-link').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');
      const clickedElementTileTitle = $clickedElement.data('title');

      const gEventLabel = clickedElementTileTitle || clickedElementLink;

      if (!gEventLabel) return;

      sendGoogleEvent(
        EVENT_CATEGORY,
        'Click',
        `Bottom deals tiles - ${gEventLabel}`,
      );
    });
  };

  const chatLinkClickEvent = () => {
    $('.js-ao-clp-columns__link[href="#chat"]').on('click', () => {
      const liveChat = new LiveChat(false, {
        sendGoogleEvent, sendAmplitudeEvent, parameters, scriptUrl, byUserInteraction, loadJs,
      }, { click_source: 'clp_block' });
      liveChat.expand();
    });
  };

  const defaultLinkClickEvent = () => {
    $('.js-ao-clp-columns__link').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');
      const trackingParams = { click_source: 'clp_block' };

      if (clickedElementLink === '/account') {
        trackingParams.ampEventName = 'check_account';
      } else if (clickedElementLink === '/customers') {
        trackingParams.ampEventName = 'help_center';
      }

      sendGoogleEvent(
        'CLP - Icons Column',
        'Click',
        clickedElementLink,
        trackingParams,
      );
    });
  };

  const initiate = () => {
    saleLinkClickEvent();
    chatLinkClickEvent();
    defaultLinkClickEvent();
  };

  return { initiate };
}
